module.exports = __webpack_public_path__ + "static/img/hkpermanent.7b2faae0.jpg";